import bounceApiClient from 'legacy/common/utils/bounceApiClient';

import {
  IncomingWorkflowCreationDto,
  IncomingWorkflowUpdateDto,
  OutgoingWorkflowListDto,
  OutgoingWorkflowDto,
  IncomingWorkflowSubmissionCreationDto,
  OutgoingWorkflowSubmissionListDto,
  OutgoingWorkflowSubmissionDto,
  IncomingWorkflowSubmissionReviewCreationDto,
  OutgoingWorkflowSubmissionReviewDto,
  WorkflowSubmissionsFilters
} from 'api/dtos/workflows/workflows';

export async function getAssociationWorkflows(
  associationId: string
): Promise<OutgoingWorkflowListDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/workflows`
  );

  return data;
}

export async function getAssociationWorkflowSubmissions({
  associationId,
  cursor,
  numberOfItems,
  filters
}: {
  associationId: string;
  cursor?: string;
  numberOfItems?: number;
  filters?: WorkflowSubmissionsFilters;
}): Promise<OutgoingWorkflowSubmissionListDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/workflows/submissions`,
    {
      params: {
        limit: numberOfItems || 20,
        cursor,
        query: filters?.query || undefined,
        status: filters?.status || undefined,
        workflowId: filters?.workflowId || undefined,
        sort: filters?.sort || undefined,
        order: filters?.order || undefined
      }
    }
  );

  return data;
}

export async function getAssociationWorkflow({
  associationId,
  workflowId
}: {
  associationId: string;
  workflowId: string;
}): Promise<OutgoingWorkflowDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/workflows/${workflowId}`
  );

  return data;
}

export async function createAssociationWorkflow({
  associationId,
  workflow
}: {
  associationId: string;
  workflow: IncomingWorkflowCreationDto;
}): Promise<OutgoingWorkflowDto> {
  const { data } = await bounceApiClient.post(
    `/api/associations/${associationId}/workflows`,
    workflow
  );

  return data;
}

export async function editAssociationWorkflow({
  associationId,
  workflowId,
  workflow
}: {
  associationId: string;
  workflowId: string;
  workflow: IncomingWorkflowUpdateDto;
}): Promise<OutgoingWorkflowDto> {
  const { data } = await bounceApiClient.put(
    `/api/associations/${associationId}/workflows/${workflowId}`,
    workflow
  );

  return data;
}

export async function deleteAssociationWorkflow({
  associationId,
  workflowId
}: {
  associationId: string;
  workflowId: string;
}): Promise<void> {
  await bounceApiClient.delete(
    `/api/associations/${associationId}/workflows/${workflowId}`
  );
}

export async function createAssociationWorkflowSubmission({
  associationId,
  workflowId,
  submission
}: {
  associationId: string;
  workflowId: string;
  submission: IncomingWorkflowSubmissionCreationDto;
}): Promise<OutgoingWorkflowSubmissionDto> {
  const { data } = await bounceApiClient.post(
    `/api/associations/${associationId}/workflows/${workflowId}/submissions`,
    submission
  );

  return data;
}

export async function getAssociationWorkflowSubmission({
  associationId,
  workflowId,
  submissionId
}: {
  associationId: string;
  workflowId: string;
  submissionId: string;
}): Promise<OutgoingWorkflowSubmissionDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/workflows/${workflowId}/submissions/${submissionId}`
  );

  return data;
}

export async function getMyWorkflowSubmissions({
  associationId,
  cursor,
  numberOfItems,
  filters
}: {
  associationId: string;
  cursor?: string;
  numberOfItems?: number;
  filters?: WorkflowSubmissionsFilters;
}): Promise<OutgoingWorkflowSubmissionListDto> {
  const { data } = await bounceApiClient.get(
    `/api/users/me/associations/${associationId}/workflows/submissions`,
    {
      params: {
        limit: numberOfItems || 20,
        cursor,
        query: filters?.query || undefined,
        status: filters?.status || undefined,
        workflowId: filters?.workflowId || undefined,
        sort: filters?.sort || undefined,
        order: filters?.order || undefined
      }
    }
  );

  return data;
}

export async function createAssociationWorkflowSubmissionReview({
  associationId,
  workflowId,
  submissionId,
  review
}: {
  associationId: string;
  workflowId: string;
  submissionId: string;
  review: IncomingWorkflowSubmissionReviewCreationDto;
}): Promise<OutgoingWorkflowSubmissionReviewDto> {
  const { data } = await bounceApiClient.post(
    `/api/associations/${associationId}/workflows/${workflowId}/submissions/${submissionId}/reviews`,
    review
  );

  return data;
}
